import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { useNavigate } from "react-router-dom";

export const Login = () => {
  const auth = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(true);
  const [mensageError, setMensageError] = useState<string | undefined>();

  const navigate = useNavigate();

  const handleLogin = async () => {
    setMensageError(undefined)
    if (email && password) {
      const isLogged = await auth.signin(email, password).then((res) => {
        try {
          if (res) {
            setError(true);
            navigate("/called");
          }
          setError(false);
        } catch (error) {
          console.log("Erro ao logar result: ", error);
          return false;
        }
      });
    }
  };

  useEffect(() => {
    if (error !== true) {
      setMensageError("Usuário ou senha inválido!");
    }
  }, [error]);

  return (<div className="login-container">
        <img src='img/logo.png' alt="Cadclin 10"/>
        <div className="form-side login-box">
          <h6 className="mb-4">Sistema de Chamadas Cadclin</h6>

          <label className="form-group has-float-label mb-4">
            <input
                className="form-control"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Digite seu E-mail"
            />
            <span>E-mail</span>
          </label>

          <label className="form-group has-float-label mb-4">
            <input
                className="form-control"
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                placeholder="Digite sua senha"
            />
            <span>Password</span>
          </label>
          {mensageError && <label style={{color: 'red'}}>{mensageError}</label>}
          <div className="d-flex justify-content-center align-items-center">
            <button
                className="btn btn-primary btn-lg btn-shadow"
                onClick={handleLogin}
            >
              LOGIN
            </button>
          </div>
        </div>
      </div>
  );
};
